// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Mkv","top":"styles_top__1MDyd"};